<template>
  <div class="carrier-info">
    <div class="carrier-info-container" v-if="orderInfo">
      <h4 class="integrated-shipment-headers">Carrier Information</h4>

      <label for="carrier">Carrier:</label>
      <select id="carrier" @change="updateCarrier">
        <option value></option>
        <option
          v-for="(carrier, index) in carrierOptions"
          :key="index"
          :value="carrier.carrier.id"
          :selected="carrier.carrier.id == orderInfo.carrier_info.carrier"
        >
          {{ carrier.carrier_name }}
        </option>
      </select>
      <label for="service">Service:</label>
      <select id="service" v-if="selectedCarrier" @change="updateService">
        <option value></option>
        <option
          v-for="(service, index) in selectedCarrier.carrier_services"
          :key="index"
          :value="service.id"
          :selected="service.id === orderInfo.carrier_info.service"
        >
          {{ service.description }}
        </option>
      </select>
      <select id="service" v-else>
        <option>Select Carrier</option>
      </select>
      <div v-if="this.$props.orderInfo.carrier_info.return_label">
        <label for="return_service">Return Service:</label>
        <select id="return_service" @change="updateReturnService">
          <option value></option>
          <option
            v-for="(return_service, index) in selectedCarrier.carrier_services"
            :key="index"
            :value="return_service.id"
            :selected="return_service.id === orderInfo.carrier_info.return_service"
          >
          {{ return_service.description }}
          </option>
        </select>
      </div>
      <div v-if="selectedCarrier">
        <label for="account_type">Payment:</label>
        <select id="account_type" @change="updateAccount" required>
          <option value></option>
          <option
            v-for="(paymentType, index) in orderInfo.payment_types"
            :key="index"
            :value="paymentType.value"
            :selected="
              orderInfo.carrier_info.payment_type === paymentType.value
            "
          >
            {{ paymentType.name }}
          </option>
        </select>
        <label for="account_number">Account Number:</label>
        <select id="account_number" @change="updateAccountNumber" required>
          <option />
          <option
            v-for="(account, index) in selectedCarrier.accounts"
            :key="index"
            :selected="
              orderInfo.carrier_info.account_number === account.account_number
            "
          >
            {{ account.account_number }}
          </option>
        </select>
        <div
          v-if="
            orderInfo.carrier_info.payment_type === 'THIRD_PARTY' ||
            orderInfo.carrier_info.payment_type === 'COLLECT'
          "
        >
          <label for="third_party_account_number">Third Party Account</label>
          <select
            id="third_party_account_number"
            @change="updateThirdPartyAccountNumber"
            required
          >
            <option />
            <option
              v-for="(account, index) in selectedCarrier.third_party_accounts"
              :key="index"
              :selected="
                orderInfo.carrier_info.third_party_account_number ===
                account.account_number
              "
            >
              {{ account.account_number }}
            </option>
          </select>
        </div>
      </div>
      <div v-if="orderInfo.carrier_info.carrier">
        <div v-if="signatureTypes != undefined">
          <label for="signature_type">POD - Signature Required:</label>
          <select id="signature_type" @change="updateSignature">
            <option value></option>
            <option
              v-for="(signatureType, index) in signatureTypes"
              :key="index"
              :value="signatureType.value"
              :selected="
                orderInfo.carrier_info.signature === signatureType.value
              "
            >
              {{ signatureType.name }}
            </option>
          </select>
        </div>
        <div
          class="special-options"
          v-if="
            selectedCarrier &&
            (selectedCarrier.carrier_name === 'FedEx' ||
              selectedCarrier.carrier_name == 'UPS')
          "
        >
          <input
            v-if="orderInfo"
            class="checkbox"
            type="checkbox"
            true-value="true"
            false-value="false"
            @change="updateReturnLabel"
            :checked="orderInfo.carrier_info.return_label"
          />
          <label class="checkbox-label" for="return_label"
            >Include Return Label</label
          >
        </div>
        <div v-if="validSaturdayService" class="special-options">
          <input
            v-if="orderInfo"
            class="checkbox"
            type="checkbox"
            true-value="true"
            false-value="false"
            @change="updateSaturdayDelivery"
            :checked="orderInfo.carrier_info.saturday_delivery"
          />
          <label class="checkbox-label">Saturday Delivery</label>
        </div>
      </div>
      <label for="service_groups">Service Group:</label>
      <select id="service_groups" @change="updateServiceGroup">
        <option></option>
        <option
          v-for="(serviceGroup, index) in orderInfo.service_groups"
          :key="index"
          :value="serviceGroup.id"
          :selected="serviceGroup.id === serviceGroupId"
        >
          {{ serviceGroup.name }}
        </option>
      </select>
      <button v-if="!emptyDimensions" @click="getRates" class="btn btn-primary">
        Rate Shop
        <font-awesome-icon
          v-if="loading"
          icon="circle-notch"
          spin
          class="loading-spinner"
        />
      </button>
    </div>
    <div class="carrier-info-container" v-else>
      <h4 class="integrated-shipment-headers">Carrier Information</h4>

      <label for="carrier">Carrier:</label>
      <select id="carrier">
        <option>Select Shipment</option>
      </select>
      <label for="service">Service:</label>
      <select id="service">
        <option>Select Shipment</option>
      </select>
    </div>
  </div>
</template>
<script>
export default {
  props: [
    "carrierOptions",
    "orderInfo",
    "selectedCarrier",
    "loading",
    "serviceGroupId",
    "invalidReturnService",
  ],
  methods: {
    updateCarrier(e) {
      this.$emit("carrierChanged", e.target.value);
    },
    updateService(e) {
      this.$emit("serviceChanged", e.target.value);
    },
    updateReturnService(e) {
      this.$emit("returnServiceChanged", e.target.value);
    },
    updateAccount(e) {
      this.$emit("accountChanged", e.target.value);
    },
    updateAccountNumber(e) {
      this.$emit("accountNumberChanged", e.target.value);
    },
    updateThirdPartyAccountNumber(e) {
      this.$emit("thirdPartyAccountNumberChanged", e.target.value);
    },
    updateSignature(e) {
      this.$emit("signatureChanged", e.target.value);
    },
    updateEmail(e) {
      this.$emit("emailChanged", e.target.value);
    },
    updateReturnLabel(e) {
      this.$emit("returnLabelChanged", e.target.checked);
    },
    updateSaturdayDelivery(e) {
      this.$emit("saturdayDeliveryChanged", e.target.checked);
    },
    updateServiceGroup(e) {
      this.$emit("serviceGroupChanged", e.target.value);
    },
    getRates() {
      this.$emit("getRates");
    },
  },
  data: function () {
    return {};
  },
  computed: {
    emptyDimensions: function () {
      return this.$props.orderInfo.ship_units.find((unit) =>
        [unit.length, unit.width, unit.height, unit.weight].includes(0)
      );
    },
    validSaturdayService() {
      return (
        [
          "FedEx 2 Day",
          "FedEx 2 Day AM",
          "FedEx Priority Overnight",
          "FedEx 2 Day AM"
        ].includes(this.$props.orderInfo.carrier_info.service) ||
        this.$props.selectedCarrier.carrier_name === "UPS"
      );
    },
    signatureTypes: function () {
      return this.$props.orderInfo.signature_types[
        `${this.$props.selectedCarrier.carrier.name.toLowerCase()}`
      ];
    },
  },
};
</script>

<style scoped>
.carrier-info {
  width: 33%;
  box-sizing: border-box;
}
.carrier-info-container {
  padding: 1rem;
  background: white;
  position: relative;
  display: inline-block;
  border: 1px solid black;
  height: 303px;
  width: 353px;
}

label {
  width: 38%;
  text-align: right;
  display: inline-block;
  vertical-align: top;
}

.special-options {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

select,
input {
  width: 52%;
  margin-bottom: 0.5rem !important;
}

.checkbox {
  width: 6%;
  margin-left: 59px;
}

h4 {
  width: 100%;
  margin: -1rem;
  margin-bottom: 1rem;
}

.checkbox-label {
  width: 58%;
  text-align: left;
}

.btn-primary {
  float: right;
  position: absolute;
  top: 12px;
  right: 10px;
}
</style>
